export default __webpack_public_path__ + "static/media/4.d3c245b0.png";